import {gql} from '@apollo/client';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

export const BIOINTELLIGENT_LINK_CONTAINER_COUNT_QUERY = gql`
  query BiointelligentLinkContainerCountQuery($id: StrictString!) @skipAudit @engComponent(name: MOLBIO) {
    polymer(id: $id) {
      ... on SequenceNode {
        id
        nucleotideType
        partContainerCount
        transcriptionContainerCount
      }
      ... on AaSequenceNode {
        id
        partContainerCount
        translationContainerCount
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;
